export const isButtonWithLabelProps = (props) => {
    return props.label !== undefined;
};
export const isButtonIconOnlyProps = (props) => {
    return props.iconOnly === true;
};
export const isButtonWithAriaLabelledByProps = (props) => {
    return props.ariaLabelledBy !== undefined;
};
export const isButtonWithChildrenProps = (props) => {
    return props.children !== undefined;
};
//# sourceMappingURL=props.js.map